import gql from 'graphql-tag'

export const FACILITY_METRICS_QUERY = gql`
  query facilityMetrics($facilityId: Int!) {
    metrics: facilityMetrics(facilityId: $facilityId) {
      fixturesTested
      samplesAnalyzed
      exceedancesFound
    }
  }
`
